export default __webpack_public_path__ + "static/GT-America-Standard-Bold-be567ff72f83015bda5bf1d6fbe04d36.woff2";